module.exports = __webpack_public_path__ + "img/lg_ring_r_c_1_1@2x.6ed77afc.png";